import { Stack } from "@mui/material";
import ImageTable from "./ImageTable";
import ReportSelector from "./ReportSelector";
import { useState, useEffect } from "react";
import ReportSelector3 from "./ReportsSelector3";
import { useUser } from "../Contexts/UserContext";
import ThreeDotLoader from "./ThreeDotLoader";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const FacilityReportPage = () => {
  const [selectedData, setSelectedData] = useState({
    branchObj: null,
    unitObj: null,
    reportObj: { ID: 0, NAME: "Select" },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [reportsDD, setReportsDD] = useState([{ ID: 0, NAME: "Select" }]);
  const { user } = useUser();
  useEffect(() => {
    const fetchInitData = async () => {
      const response = await fetch(
        `${API_URL}/facility/GetClientReportList/${user.ClientId}`
      ).then((res) => res.json());
      console.log(response);
      if (response.success) {
        setReportsDD([{ ID: 0, NAME: "Select" }, ...response.data]);
      } else {
        alert(response.message);
      }
    };
    fetchInitData();
  }, []);
  const handleFetchReports = async () => {
    setIsLoading(true);
    var api_url;
    if (selectedData.unitObj.UnitCode == "0") {
      api_url = `${API_URL}/facility/get-facility-reports/4/${user.CompCode}/${user.ClientId}/${selectedData.unitObj.UnitCode}/${selectedData.reportObj.ID}/${fromDate}/${toDate}`;
    } else {
      api_url = `${API_URL}/facility/get-facility-reports/1/${user.CompCode}/${user.ClientId}/${selectedData.unitObj.UnitCode}/${selectedData.reportObj.ID}/${fromDate}/${toDate}`;
    }
    const response = await fetch(api_url).then((res) => res.json());
    if (response.success) {
      setIsLoading(false);
      setTableData(response.data);
    } else {
      setIsLoading(false);
      alert("API CONNECTION ERROR");
    }
  };
  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <ReportSelector3
          title="Facility Reports"
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          toDate={toDate}
          setToDate={setToDate}
          fromDate={fromDate}
          setFromDate={setFromDate}
          handleFetchReports={() => handleFetchReports()}
          reportTypeList={reportsDD}
        />
        {isLoading ? <ThreeDotLoader /> : <ImageTable data={tableData} />}
      </div>
    </>
  );
};
export default FacilityReportPage;
